<template>
  <div class="home">
    <div class="towns">
      {{ town_name }}
    </div>
    <Flow></Flow>

    <!-- <First></First> -->
    <Second></Second>
    <Third></Third>
  </div>
</template>

<script>
// @ is an alias to /src
import Flow from '@/components/Home/First/交易流程.vue'
import First from '@/components/Home/X_First.vue'
import Second from '@/components/Home/Second.vue'
import Third from '@/components/Home/Third.vue'

export default {
  data () {
    return {
      time: '',
      town_name: '',
    }
  },
  components: {
    Flow,
    First,
    Second,
    Third,
  },
  watch: {
    $route: {
      handler: function (val, oldVal) {
        console.log(val)
        console.log(oldVal)
        location.reload()
      },
      // 深度观察监听
      deep: true,
    },
  },
  created () {
    // setInterval(() => {

    //   this.today()
    // }, 1000);
    this.time = this.today()
    // 赋值名字
    console.log(this.$route.query)
    this.town_name = this.$route.query.deptName
  },
  methods: {
    today () {
      var d = new Date(),
        show_day = new Array(
          '星期日',
          '星期一',
          '星期二',
          '星期三',
          '星期四',
          '星期五',
          '星期六'
        ),
        day = d.getDay(),
        str = ''
      str += d.getFullYear() + '年' //获取当前年份
      str += d.getMonth() + 1 + '月' //获取当前月份（0——11）
      str += d.getDate() + '日'
      str += ' ' + show_day[day]
      // str += d.getHours() + '时';
      // str += d.getMinutes() + '分';
      // str += d.getSeconds() + '秒';
      // console.log(str);
      return str
    },
  },
}
</script>
<style scoped>
.home {
  margin: 0 auto;
  /* padding: 5px 28px 35px 28px; */
  /* padding: 5px 18px 35px 18px; */
  width: 1864px;
  height: auto;
  /* background-color: #f5f5f5; */
  /* background-color: chocolate; */
}

.time {
  width: 100%;
  height: 84px;
  background-color: rgb(255, 255, 255);
  overflow: hidden;
  margin-bottom: 10px;
}

.time > span {
  padding-left: 68px;
  width: auto;
  height: 84px;
  font-size: 28px;
  line-height: 84px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
}

.towns {
  width: 100%;
  /* height: 140px; */
  background-color: rgb(255, 255, 255);
  /* border: #2187FF 1px solid; */
  /* box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.3); */
  box-shadow: 0px 0px 8px 0px #2187ff;
  overflow: hidden;
  margin-bottom: 10px;
  height: 144px;
  line-height: 144px;
  text-align: center;
  font-size: 37px;
  color: #2187ff;
  margin-top: 10px;
}

.towns > p {
  padding-left: 68px;
  width: auto;
  height: 84px;
  line-height: 84px;
  text-align: center;
  font-size: 37px;
  font-family: Microsoft YaHei;
  font-weight: bold;
}
</style>
